import React from "react";
import styles from "./index.module.scss";
// import AvatarC from "../../../avatar";
import { FlipperVaultCardProps } from "../../index";

export default function ExpiredByOther({
  flipperData,
  type
}: {
  flipperData: FlipperVaultCardProps;
  type?: string;
}) {
  return (
    <div
      className={`${styles.releaseBtnWrap} ${
        flipperData?.checkouts !== null &&
        flipperData?.checkouts?.[0]?.releasedAt === null &&
        styles.Blur
      } ${type === "list" ? styles.list : ""}`}
    >
      <div className={styles.FlipperVaultCardOwner}>
        <div>
          <div className={styles.FlipperVaultCardOwnerTitle}>
            CHECKED OUT BY
          </div>
          <div className={styles.FlipperVaultCardOwnerValue}>
            {flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]
              ?.userName || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}
